/* Hey Hottie — the two pages that need to think
 *
 *   1. Build a bundle  — pick N, watch the arithmetic, add them all at once.
 *   2. The finder      — a few questions, one product.
 *
 * Both run entirely in the page. The finder never touches the network at all;
 * the bundle only does when someone actually adds. That is deliberate: these
 * are the two places a shopper is furthest from a decision, and a spinner
 * between them and the answer is where they leave.
 */
(function () {
  'use strict';

  function root() {
    return ((window.Shopify && window.Shopify.routes) || {}).root || '/';
  }

  /* ══════════════════════════════════════════════════════════════════════
     Build a bundle
     ══════════════════════════════════════════════════════════════════════ */

  function moneyFn(box) {
    var code = box.getAttribute('data-currency') || 'USD';
    var fmt;
    try {
      fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: code
      });
    } catch (e) {
      fmt = null;
    }
    return function (cents) {
      var n = cents / 100;
      if (fmt) return fmt.format(n);
      return '$' + n.toFixed(2);
    };
  }

  function paintBundle(box) {
    var buy = parseInt(box.getAttribute('data-buy'), 10);
    var get = parseInt(box.getAttribute('data-get'), 10);
    if (isNaN(buy)) buy = 2;
    if (isNaN(get)) get = 1;

    var want = parseInt(box.getAttribute('data-pick'), 10) || buy + get;
    var pct = parseFloat(box.getAttribute('data-getpct')) || 0;
    var money = moneyFn(box);

    var chosen = [].slice.call(box.querySelectorAll('[data-hh-pick].hh-pick--on'));
    var prices = chosen.map(function (el) {
      return parseInt(el.getAttribute('data-price'), 10) || 0;
    });
    var sub = prices.reduce(function (a, b) { return a + b; }, 0);

    var full = chosen.length === want;

    /* Shopify's Buy X get Y takes the discount off the LOWEST priced
       qualifying items. Showing anything else here would put a number on the
       page that disagrees with checkout. */
    var save = 0;
    if (full && get > 0 && pct > 0) {
      var cheapest = prices.slice().sort(function (a, b) { return a - b; }).slice(0, get);
      save = cheapest.reduce(function (a, p) { return a + Math.round((p * pct) / 100); }, 0);
    }

    /* Slots */
    var slots = box.querySelectorAll('[data-hh-slots] .hh-slot');
    for (var i = 0; i < slots.length; i++) {
      var pick = chosen[i];
      if (pick) {
        slots[i].textContent = pick.getAttribute('data-title') || '';
        slots[i].classList.add('hh-slot--full');
      } else {
        slots[i].textContent = slots[i].getAttribute('data-empty') || slots[i].dataset.empty || '';
        slots[i].classList.remove('hh-slot--full');
      }
    }

    var set = function (sel, text) {
      var el = box.querySelector(sel);
      if (el) el.textContent = text;
    };
    set('[data-hh-subtotal]', money(sub));
    set('[data-hh-save]', '−' + money(save));
    set('[data-hh-total]', money(sub - save));

    var saveRow = box.querySelector('[data-hh-saverow]');
    if (saveRow) saveRow.hidden = save === 0;

    var btn = box.querySelector('[data-hh-bundle-add]');
    if (btn) btn.disabled = !full;

    var hint = box.querySelector('[data-hh-hint]');
    if (hint) {
      var left = want - chosen.length;
      hint.hidden = left <= 0;
      if (left > 0) {
        /* Before they have picked anything the merchant's own wording stands.
           Once they are mid-bundle, a live count is more use than a slogan. */
        hint.textContent =
          chosen.length === 0
            ? hint.getAttribute('data-first') || hint.textContent
            : 'Pick ' + left + ' more.';
      }
    }

    /* Once they are full, the unpicked ones stop inviting a click they
       cannot make. Disabling them outright would be worse — they'd have no
       way to see they can swap — so they just go quiet. */
    var all = box.querySelectorAll('[data-hh-pick]');
    for (var j = 0; j < all.length; j++) {
      var on = all[j].classList.contains('hh-pick--on');
      all[j].classList.toggle('hh-pick--dim', full && !on);
    }
  }

  function initBundles() {
    var boxes = document.querySelectorAll('[data-hh-bundle]');
    for (var i = 0; i < boxes.length; i++) {
      var slots = boxes[i].querySelectorAll('[data-hh-slots] .hh-slot');
      for (var j = 0; j < slots.length; j++) {
        slots[j].setAttribute('data-empty', slots[j].textContent.trim());
      }
      var h = boxes[i].querySelector('[data-hh-hint]');
      if (h && !h.getAttribute('data-first')) {
        h.setAttribute('data-first', h.textContent.trim());
      }
      paintBundle(boxes[i]);
    }
  }

  document.addEventListener('click', function (e) {
    var pick = e.target.closest('[data-hh-pick]');
    if (pick && !pick.disabled) {
      var box = pick.closest('[data-hh-bundle]');
      if (!box) return;
      var want = parseInt(box.getAttribute('data-pick'), 10) || 3;
      var on = pick.classList.contains('hh-pick--on');

      if (!on && box.querySelectorAll('.hh-pick--on').length >= want) return;

      pick.classList.toggle('hh-pick--on', !on);
      pick.setAttribute('aria-pressed', String(!on));
      paintBundle(box);
      return;
    }

    var add = e.target.closest('[data-hh-bundle-add]');
    if (!add || add.disabled) return;

    var wrap = add.closest('[data-hh-bundle]');
    if (!wrap) return;

    var items = [].slice.call(wrap.querySelectorAll('.hh-pick--on')).map(function (el) {
      return { id: el.getAttribute('data-hh-pick'), quantity: 1 };
    });
    if (!items.length) return;

    add.disabled = true;
    var err = wrap.querySelector('[data-hh-bundle-error]');
    if (err) err.hidden = true;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'Could not add');
          return d;
        });
      })
      .then(function () {
        /* If the saving comes from a CODE rather than an automatic discount,
           hand the code to Shopify on the way to the cart. /discount/CODE
           applies it to the session and forwards — so the shopper never types
           anything, and the page stops promising a saving that depends on
           them remembering one. The code is still printed on the page for
           anyone who gets to checkout another way. */
        var code = (wrap.getAttribute('data-hh-code') || '').trim();
        if (code) {
          window.location.href =
            root() + 'discount/' + encodeURIComponent(code) + '?redirect=/cart';
          return;
        }
        window.location.reload();
      })
      .catch(function (e2) {
        add.disabled = false;
        if (err) {
          err.textContent = 'Could not add those just now.';
          err.hidden = false;
        }
        console.warn('[hey hottie] bundle add failed:', e2);
      });
  });

  /* ══════════════════════════════════════════════════════════════════════
     The finder
     ══════════════════════════════════════════════════════════════════════ */

  function quizPaint(quiz) {
    var step = quiz.__step || 0;
    var steps = quiz.querySelectorAll('[data-hh-step]');
    var results = quiz.querySelectorAll('.hh-quiz__result');
    var dots = quiz.querySelectorAll('[data-hh-dot]');

    for (var i = 0; i < results.length; i++) results[i].hidden = true;
    for (var j = 0; j < steps.length; j++) steps[j].hidden = j !== step;
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('on', k <= step);
  }

  function quizAnswer(quiz) {
    var answers = quiz.__answers || [];
    var outcomes = quiz.querySelectorAll('[data-hh-outcome]');

    for (var i = 0; i < outcomes.length; i++) {
      var raw = (outcomes[i].getAttribute('data-hh-outcome') || '')
        .toLowerCase()
        .split(',')
        .map(function (s) {
          return s.trim();
        })
        .filter(Boolean);

      var all = true;
      for (var j = 0; j < raw.length; j++) {
        if (answers.indexOf(raw[j]) === -1) {
          all = false;
          break;
        }
      }
      if (all) return outcomes[i];
    }
    return quiz.querySelector('[data-hh-outcome-none]');
  }

  function quizFinish(quiz) {
    var steps = quiz.querySelectorAll('[data-hh-step]');
    for (var i = 0; i < steps.length; i++) steps[i].hidden = true;

    var results = quiz.querySelectorAll('.hh-quiz__result');
    for (var j = 0; j < results.length; j++) results[j].hidden = true;

    var win = quizAnswer(quiz);
    if (win) win.hidden = false;

    var dots = quiz.querySelectorAll('[data-hh-dot]');
    for (var k = 0; k < dots.length; k++) dots[k].classList.add('on');
  }

  document.addEventListener('click', function (e) {
    var ans = e.target.closest('[data-hh-answer]');
    if (ans) {
      var quiz = ans.closest('[data-hh-quiz]');
      if (!quiz) return;
      quiz.__answers = (quiz.__answers || []).concat([
        (ans.getAttribute('data-hh-answer') || '').toLowerCase()
      ]);
      quiz.__step = (quiz.__step || 0) + 1;

      if (quiz.__step >= quiz.querySelectorAll('[data-hh-step]').length) {
        quizFinish(quiz);
      } else {
        quizPaint(quiz);
      }
      return;
    }

    var back = e.target.closest('[data-hh-quiz-back]');
    if (back) {
      var q2 = back.closest('[data-hh-quiz]');
      if (!q2) return;
      q2.__answers = (q2.__answers || []).slice(0, -1);
      q2.__step = Math.max(0, (q2.__step || 0) - 1);
      quizPaint(q2);
      return;
    }

    var reset = e.target.closest('[data-hh-quiz-reset]');
    if (reset) {
      var q3 = reset.closest('[data-hh-quiz]');
      if (!q3) return;
      q3.__answers = [];
      q3.__step = 0;
      quizPaint(q3);
    }
  });

  /* ══════════════════════════════════════════════════════════════════════
     Spotlight — one time vs auto-ship
     ══════════════════════════════════════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-hh-opt]');
    if (opt) {
      var box = opt.closest('[data-hh-spot]');
      if (!box) return;
      var all = box.querySelectorAll('[data-hh-opt]');
      for (var i = 0; i < all.length; i++) {
        var on = all[i] === opt;
        all[i].classList.toggle('hh-spot__opt--on', on);
        all[i].setAttribute('aria-pressed', String(on));
      }
      return;
    }

    var add = e.target.closest('[data-hh-spot-add]');
    if (!add || add.disabled) return;

    var sec = add.closest('.hh-spot__words') || document;
    var chosen = sec.querySelector('[data-hh-opt].hh-spot__opt--on');
    var body = { id: add.getAttribute('data-variant'), quantity: 1 };
    var plan = chosen && chosen.getAttribute('data-plan');
    if (plan) body.selling_plan = plan;

    add.disabled = true;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (d) {
          if (!res.ok) throw new Error(d.description || d.message || 'Could not add');
          return d;
        });
      })
      .then(function () { window.location.reload(); })
      .catch(function (err) {
        add.disabled = false;
        console.warn('[hey hottie] spotlight add failed:', err);
      });
  });

  /* ══════════════════════════════════════════════════════════════════════ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundles);
  } else {
    initBundles();
  }

  /* The theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', initBundles);
})();
